import clsx from 'clsx';
import * as React from 'react';
import { observer } from 'mobx-react';
import WhoIsItFor from './WhoIsItFor';
import Competencies from './Competencies';
import { T } from '../../../../../../Translations';
import LearningCollectionStore from '../../../Store';
import { emptyFragment } from '../../../../../../EmptyFragment';
import IncludesFollowingContent from './IncludesFollowingContent';

interface Props {
  store: LearningCollectionStore;
}

const Right: React.FC<Props> = ({ store }) =>
  store.activeSelectedProductLicense
    .map((productLicense) => (
      <div
        className={clsx(
          'mt-8 h-fit border border-solid bg-white py-6 pl-7 pr-3',
          'hidden border-[#D9DADD] lg:block lg:basis-[35%]',
        )}
      >
        <h4 className="font-semibold text-[#202532]">
          <T kind="More details about this license" />
        </h4>
        <WhoIsItFor productLicense={productLicense} />
        <IncludesFollowingContent productLicense={productLicense} />
        <Competencies productLicense={productLicense} />
      </div>
    ))
    .getOrElse(emptyFragment);

export default observer(Right);
